import {  Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject, Subscription,interval } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { EzoChatAppService } from '../../../@theme/components/common/service/ezo-chat-app.service'; 
import { PhysicianData } from '../../../@core/interfaces/masters/physician-mst';
import { ActivatedRoute } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { TitleService } from '../../../@theme/components/common/service/title.service';
import { switchMap } from 'rxjs/operators';

const spinnerLoadtext = "Data Loading are in progress. Please wait";

@Component({
  selector: 'ngx-queuemanagement',
  templateUrl: './queuemanagement.component.html',
  styleUrls: ['./queuemanagement.component.scss']
})
export class QueuemanagementComponent implements OnInit {
  
  protected readonly unsubscribe$ = new Subject<void>();
  private subscription!: Subscription;

  loadText = "";
  aptpervious: number = 1;
  skip: any = 0;
  take: any = 100;
  customerId:string;
  passCode:string;
  showError:boolean=false;
  physicianConfiguration:Array<any>=[];
  deviceCodeDropdownList:Array<any>=[];

  appointmentQueueList:Array<any>=[];
  selectedDeviceList:Array<any>=[];
  errorMessage:string;
 CurrentTime:string;
 currentDate=new Date();
 physicianRoomDetails:Array<any>=[];
  displayColumnSetupData: any=[];
  enableDeviceSetup:boolean=false;

  //branchDetails
  branchName:string;
  branchPhoneNumber:string;
  branchCity:string;
  tenantName:string;
  branchArea:string;
  deviceList:string;
  constructor(
    private spinner: NgxSpinnerService,  public titleService: TitleService,public datService: DateService,public chatService:EzoChatAppService,
    private patSrvc: PatientAppointmentData,private idle: Idle, private route: ActivatedRoute, protected phySrvc: PhysicianData) { 

      
    setInterval(() => {
      var date = new Date();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var sec = date.getSeconds();

      var ampm = hours >= 12 ? 'pm' : 'am';
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'
      var _minutes = minutes < 10 ? '0' + minutes : minutes;
      var _sec = sec < 10 ? '0' + sec : sec;
      var strTime = hours + ':' + _minutes + ':' + _sec + ' ' + ampm;
      this.CurrentTime = strTime;
    }, 1);
    this.route.params.subscribe(params => {
      this.customerId = params['customerId'];
      this.passCode = params['passCode'];
      this.deviceList= params['deviceId']
    });
  }
  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  ngOnInit(): void {
    this.idle.stop();
    this.searchCall(true);
    this.subscription = interval(4000)
    .pipe(switchMap(() => this.searchCall(false))) 
    .subscribe(response => {
    });
  
  }
  ngAfterViewInit(): void {
    this.pageAutoRefresh();
    this.getAptStatus();
  }
  
  utcToMyDate(myDate) {
    if (myDate !== null && myDate !== undefined) {
      return this.datService.dateUtctoLocalDateAndTime(myDate)
    }
  }
    
  enableDeviceSetupOption(){
    if (this.deviceList != null && this.deviceList != undefined){
      this.enableDeviceSetup = false
    } else {
    this.enableDeviceSetup = !this.enableDeviceSetup;
    }
  }
  async searchCall(isLoadBranchData) { 
    let searchData = {
      fromDate: this.datService.utcFromDate(new Date()),
      toDate: this.datService.utcToDate(new Date()),
      skip: this.skip,
      take: this.take,
      customerId:this.customerId,
      passCode:this.passCode,
      deviceIds:this.selectedDeviceList,
      loadBranchDetails:isLoadBranchData,
      deviceCode:this.deviceList,
    }; 
    this.loadText = spinnerLoadtext;
    this.spinner.show(); 
    
    this.patSrvc.searchList("queueManagement/queueManagementWithoutlogin",searchData).pipe(takeUntil(this.unsubscribe$)).subscribe(
        (data: any) => {  
          this.appointmentQueueList=data.details;
          localStorage.setItem("tenantId", data.tenantId);
          localStorage.setItem("branchId", data.branchId);
          localStorage.setItem("userId", data.userId);
          this.displayColumnSetupData=data.columnSetup;
          this.physicianConfiguration=data.physicianConfiguration;
          if(this.deviceCodeDropdownList.length<this.groupByMonitorId(data.physicianConfiguration).length){
            this.deviceCodeDropdownList=this.groupByMonitorId(data.physicianConfiguration);
          }
          if(isLoadBranchData){
            this.branchName=data.branchDetails.branchName;
            this.branchPhoneNumber=data.branchDetails.phoneNumber;
            this.branchCity=data.branchDetails.city;
            this.tenantName=data.branchDetails.area;
            this.branchArea=data.branchDetails.tenantName;

          }
          this.chatService.startConnection();
        },
        (error) => {  
          if(error.error!=null){
            this.errorMessage=error.error.details.message;
          }else{
            this.errorMessage="Failed to setup Queue Management";
          }
          this.showError=true;
          this.spinner.hide();
          setTimeout(() => {
            this.showError=false;
          }, 8000);
        },
        () => {
          this.spinner.hide();
        }
     );
  }

  groupByMonitorId(data: any[]) {
    const groupedData = [];
    const groupedMap = new Map();
  
    data.forEach(item => {
      if (!groupedMap.has(item.monitorId)) {
        groupedMap.set(item.monitorId, { monitorId: item.monitorId, monitorName: item.monitorName, options: [] });
      }
      groupedMap.get(item.monitorId).options.push(item);
    });
  
    groupedMap.forEach(value => groupedData.push(value));
    return groupedData;
  }


  getRoomNumber(physicianId):string{
    if(physicianId==undefined || physicianId==null){return "-";}
    if(this.physicianConfiguration.length){
     const roomNumbers = this.physicianConfiguration.filter(e=>e.phyId ==physicianId).map(s=>s.roomNo);
     const uniqueNo =  Array.from(new Set(roomNumbers));
     return uniqueNo.length?  uniqueNo.join(','):'-';
    }
   return "-";
  }
    onChangeDeviceSetup(event:any){

      this.selectedDeviceList = event?.map(item => item.value) || [];  
        this.searchCall(false);
    }

  prevclicked() {
    if (this.aptpervious > 1)
      this.aptpervious = this.aptpervious - 1

  }

  nextclicked() {
    if (this.aptpervious < (this.appointmentQueueList.length / 10)) {
      this.aptpervious = this.aptpervious + 1
    }
    else {
      this.skip = this.skip + 100;
      this.searchCall(false);
    }
  }

getPatientTitle(title):string{
  if(title==undefined && title=="" && title==null){ return "";}
  return this.titleService.getTitle(title);
}

  getAptStatus(){
    this.chatService.aptQueueUpdate.pipe(filter(res => !!res)).subscribe(aptupdate => {
      var data=this.appointmentQueueList
        .map(x=>{
        if(x.id==aptupdate?.aptData?.id)
            x.queueStatus=aptupdate?.type;
        return x;
      })
      this.searchCall(false);
    });  
  }

  pageAutoRefresh(){
    this.chatService.pageRefresh$.pipe(filter(res => !!res)).subscribe(pagenameList => {
        if(!!pagenameList?.find(x=>{return x==this.chatService.appointmentQueuepname})){
          this.searchCall(false);
          document.getElementById("pageload").click();
        }
    });    
  }

  getPatientAgeByDOB(dob, ageResult, dobFlag){
    return this.datService.getPatientAgeByDOB(dob,ageResult,dobFlag);
  }

}
